"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = require("styled-components");

var _components = require("../../components");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** Child node to panel content */
  children: _propTypes.node,

  /** Description font color */
  color: _propTypes.string,

  /** Number of columns in grid */
  columns: (0, _propTypes.arrayOf)(_propTypes.number),

  /** A boolean to set whether the dark version of the cta is used */
  darkUi: _propTypes.bool,

  /** Description text usually a text, but can be a React component */
  description: _propTypes.node,

  /** Image source */
  imageAbove: _propTypes.node,

  /** Image source */
  imageBelow: _propTypes.node,

  /** Title text usually a text, but can be a React component */
  title: _propTypes.node,

  /** Colour code for title */
  titleColor: _propTypes.string,

  /** Height of title */
  titleHeight: _propTypes.number,

  /** Title ref */
  titleRef: _propTypes.string
};

var FlexItemOne = function FlexItemOne(_ref) {
  var color = _ref.color,
      columns = _ref.columns,
      children = _ref.children,
      description = _ref.description,
      title = _ref.title,
      darkUi = _ref.darkUi,
      titleHeight = _ref.titleHeight,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow,
      titleColor = _ref.titleColor,
      titleRef = _ref.titleRef;
  var defaultDescriptionColor = darkUi ? "text-light" : "text";
  var defaultTitleColor = darkUi ? "text-light" : "text-title";
  var descriptionFont = {
    color: color || defaultDescriptionColor,
    fontSize: [3, 3, 3, 3, 3, 4],
    fontWeight: 1,
    lineHeight: 3,
    textAlign: "left"
  };
  var titleFont = {
    color: titleColor || defaultTitleColor,
    fontSize: [4, 4, 4, 4, 5, 5],
    fontWeight: 2,
    height: titleHeight,
    lineHeight: 2,
    mb: 2,
    textAlign: "left"
  };
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "flex-start",
    columns: columns,
    flexDirection: "column",
    justifyContent: "flex-start",
    p: 4,
    px: [0, 0, "12px", "12px", 2, 2]
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "flex-start",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: [1, 2],
    justifyContent: "flex-start",
    title: /*#__PURE__*/_react["default"].createElement("span", {
      ref: titleRef
    }, title),
    titleFont: titleFont
  }), children);
};

FlexItemOne.propTypes = propTypes;
FlexItemOne.displayName = "Modules.FlexItemOne";

var _default = (0, _styledComponents.withTheme)(FlexItemOne);

exports["default"] = _default;